// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReferalLisr_wrapper__AMkbo {
    max-width: 350px;  
    justify-content: center;
    display: flex;
    margin:0 auto;
    /* flex-direction: column; */
}

.ReferalLisr_container__mtRN- {
  
    text-align: left;
    width: 90%;
    /* max-width: 350px; */
}

.ReferalLisr_boldText__371sf {
    font-weight: bold;
    margin-bottom: 10px;
}

.ReferalLisr_list__8jJAv {
    height: 150px;
    overflow: auto;
    
}

.ReferalLisr_item__Gfv9Q {
    /* margin-top: 5px; */
    /* margin-bottom: 5px; */
    border-bottom: 1px solid #ffc843;
    padding: 5px 0px;
}

.ReferalLisr_noFriend__VxOEm {
    color:#848484;
    opacity: 70%;
    font-weight: 300;
}`, "",{"version":3,"sources":["webpack://./src/Components/Referal/ReferalList/ReferalLisr.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,4BAA4B;AAChC;;AAEA;;IAEI,gBAAgB;IAChB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;;AAElB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".wrapper {\n    max-width: 350px;  \n    justify-content: center;\n    display: flex;\n    margin:0 auto;\n    /* flex-direction: column; */\n}\n\n.container {\n  \n    text-align: left;\n    width: 90%;\n    /* max-width: 350px; */\n}\n\n.boldText {\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.list {\n    height: 150px;\n    overflow: auto;\n    \n}\n\n.item {\n    /* margin-top: 5px; */\n    /* margin-bottom: 5px; */\n    border-bottom: 1px solid #ffc843;\n    padding: 5px 0px;\n}\n\n.noFriend {\n    color:#848484;\n    opacity: 70%;\n    font-weight: 300;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ReferalLisr_wrapper__AMkbo`,
	"container": `ReferalLisr_container__mtRN-`,
	"boldText": `ReferalLisr_boldText__371sf`,
	"list": `ReferalLisr_list__8jJAv`,
	"item": `ReferalLisr_item__Gfv9Q`,
	"noFriend": `ReferalLisr_noFriend__VxOEm`
};
export default ___CSS_LOADER_EXPORT___;
